import { typeof as _typeof, slicedToArray as _slicedToArray, extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef, useEffect } from 'react';
import { IconButton, Box, Checkbox } from '@chakra-ui/react';
import { i18n } from '../../../../i18n/translate.js';
import { Layout } from '../../Layout/component.js';
import { Icon } from '../../Icon/component.js';
var _excluded = ["indeterminate", "className", "isLoadingData", "selectHandler", "selectedProp", "header"];
var iconButtonProps = {
  variant: 'ghost',
  colorScheme: 'gray',
  size: '2xs',
  m: -1,
  me: 2
};
var IndeterminateCheckbox = function IndeterminateCheckbox(_ref) {
  var indeterminate = _ref.indeterminate;
  _ref.className;
  var isLoadingData = _ref.isLoadingData,
    selectHandler = _ref.selectHandler,
    selectedProp = _ref.selectedProp,
    header = _ref.header,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ref = useRef(null);
  useEffect(function () {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);
  var _onChange = function onChange(event, rest, selectHandler, selectedProp) {
    if (!header && selectHandler) {
      selectHandler(selectedProp, event.target.checked);
    }
    rest.onChange(event);
  };
  return /*#__PURE__*/React.createElement(Checkbox, {
    isChecked: rest.checked,
    checked: rest.checked,
    disabled: isLoadingData || rest.disabled,
    onChange: function onChange(event) {
      return _onChange(event, rest, selectHandler, selectedProp);
    },
    ref: ref,
    isIndeterminate: indeterminate,
    me: "2"
  });
};
IndeterminateCheckbox.displayName = "IndeterminateCheckbox";
var ExpandRowButton = function ExpandRowButton(_ref2) {
  var toggleExpand = _ref2.toggleExpand,
    isExpanded = _ref2.isExpanded;
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    onClick: toggleExpand
  }, iconButtonProps, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "caret-right",
      transform: isExpanded ? 'rotate-90' : undefined
    }),
    "aria-label": isExpanded ? i18n.t('Collapse') : i18n.t('Expand'),
    isActive: isExpanded
  }));
};
ExpandRowButton.displayName = "ExpandRowButton";
var NestedData = function NestedData(_ref3) {
  var expandedData = _ref3.expandedData,
    content = _ref3.content;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  function ToggleNestedData() {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    onClick: ToggleNestedData
  }, iconButtonProps, {
    isActive: isOpen,
    icon: isOpen ? /*#__PURE__*/React.createElement(Icon, {
      iconName: "angle-up"
    }) : /*#__PURE__*/React.createElement(Icon, {
      iconName: "angle-down"
    }),
    "aria-label": isOpen ? i18n.t('Collapse') : i18n.t('Expand')
  })), content), isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, expandedData === null || expandedData === void 0 ? void 0 : expandedData.map(function (data, dataIndex) {
    var _data$id;
    var expandedDataKey = "expanded-data-".concat((_data$id = data.id) === null || _data$id === void 0 ? void 0 : _data$id.toString(), "-").concat(dataIndex);
    return /*#__PURE__*/React.createElement(Box, {
      ps: "lg",
      pt: "xs",
      key: expandedDataKey
    }, data.title);
  })));
};
var SetColumnProps = function SetColumnProps(columns) {
  columns.forEach(function (column) {
    // for older legacy tables not including id's
    if (!column.id) {
      var _column$title;
      column.id = column.name ? column.name : (_column$title = column.title) === null || _column$title === void 0 ? void 0 : _column$title.toLowerCase();
    }
    if (!column.header) {
      var _column$title2;
      column.header = column.name ? column.name : (_column$title2 = column.title) === null || _column$title2 === void 0 ? void 0 : _column$title2.toLowerCase();
    }
    if (!column.accessorKey) {
      column.accessorKey = column.id;
    }
  });
};

// TODO: Need to have a more efficient way of handling the multiple
// cell formatting use cases for foundry and legacy sdk tables
var SetCellTemplate = function SetCellTemplate(column, row, cellIndex, id) {
  if (row[id] && _typeof(row[id]) === 'object') {
    var _row$id;
    if (((_row$id = row[id]) === null || _row$id === void 0 ? void 0 : _row$id.length) > 0) {
      for (var key in row[id]) {
        if (_typeof(row[id][key]) === 'object' && 'values' in row[id][key]) {
          return column.cellTemplate(row[id], column, cellIndex);
        }
      }
    }
    // check for legacy sdk cells first
    if (row.cells) {
      return column.cellTemplate(row, column, cellIndex);
    }
    // return cell template based on cell contents
    return row[id] ? column.cellTemplate(row[id], row) : column.cellTemplate(column, row, cellIndex);
  }
  return column.cellTemplate(row[column.name], row);
};
export { ExpandRowButton, IndeterminateCheckbox, NestedData, SetCellTemplate, SetColumnProps };